module.exports = __webpack_public_path__ + "img/MarketFlash.c0f0f1f.jpg";